import InfoPage from '@/components/InfoPage';

const PoliticaPrivacidade = () => {
  return (
    <InfoPage title="Política de Privacidade">
      <div className="space-y-6 text-gray-700">
        <p><strong>Última atualização:</strong> Janeiro de 2025</p>
        
        <section>
          <h2 className="text-xl font-semibold mb-3" style={{ color: '#302681' }}>1. Informações que Coletamos</h2>
          <p>Coletamos informações que você nos fornece diretamente:</p>
          <ul className="list-disc list-inside mt-2 space-y-1">
            <li>Endereço de email para criação de conta</li>
            <li>Localização geográfica para exibir estacionamentos próximos</li>
            <li>Informações de estacionamentos cadastrados por proprietários</li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3" style={{ color: '#302681' }}>2. Como Usamos Suas Informações</h2>
          <p>Usamos as informações coletadas para:</p>
          <ul className="list-disc list-inside mt-2 space-y-1">
            <li>Fornecer, operar e manter nosso serviço</li>
            <li>Melhorar e personalizar sua experiência</li>
            <li>Desenvolver novos recursos e funcionalidades</li>
            <li>Comunicar-nos com você sobre atualizações e suporte</li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3" style={{ color: '#302681' }}>3. Compartilhamento de Informações</h2>
          <p>Não vendemos suas informações pessoais. Podemos compartilhar informações apenas:</p>
          <ul className="list-disc list-inside mt-2 space-y-1">
            <li>Com seu consentimento explícito</li>
            <li>Para cumprir obrigações legais</li>
            <li>Com provedores de serviços que nos auxiliam na operação</li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3" style={{ color: '#302681' }}>4. Segurança</h2>
          <p>
            Implementamos medidas de segurança para proteger suas informações pessoais. Utilizamos Firebase Authentication e criptografia para proteger dados sensíveis.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3" style={{ color: '#302681' }}>5. Seus Direitos (LGPD)</h2>
          <p>De acordo com a Lei Geral de Proteção de Dados (LGPD), você tem direito a:</p>
          <ul className="list-disc list-inside mt-2 space-y-1">
            <li>Confirmar a existência de tratamento de dados</li>
            <li>Acessar seus dados pessoais</li>
            <li>Corrigir dados incompletos ou desatualizados</li>
            <li>Solicitar a eliminação de dados</li>
            <li>Revogar consentimento</li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3" style={{ color: '#302681' }}>6. Contato</h2>
          <p>Para questões sobre privacidade, entre em contato:</p>
          <p className="mt-2">Email: privacidade@parkingspot.com.br</p>
        </section>
      </div>
    </InfoPage>
  );
};

export default PoliticaPrivacidade;
